import router from '@/modules/addFunds/router'
import { useFundsStore } from '@/modules/addFunds/store'
import FundsApi from '@/modules/addFunds/service'

export default {
  router,
  service: new FundsApi(),
  store: useFundsStore,
}
